<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      unit="信息通告"
      id-key="ArticleId"
      edit-title
      :data="data"
      show-save-button
      :save-button-text="data.Status==0?'保 存':'发 布'"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="标题" prop="Title">
              <el-input v-model="data.Title" placeholder="填写标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="$store.state.isMB" :span="24">
            <el-form-item label="置顶">
              <el-checkbox v-model="data.IsTop"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col v-else :span="2">
            <el-form-item label-width="0px">
              <span style="margin: 0px 15px;">置顶</span>
              <el-checkbox v-model="data.IsTop"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="发布人" prop="Publisher">
              <el-input v-model="data.Publisher" placeholder="填写发布人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="发布时间" prop="PublishTime">
              <el-date-picker
                size="mini"
                v-model.trim="data.PublishTime"
                placeholder="请选择日期"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="信息来源" prop="Source">
              <el-input type="textarea" v-model="data.Source" placeholder="填写信息来源"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="0">草稿</el-radio>
                <el-radio :label="1">发布</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>信息通告内容</el-divider>
        <el-row>
          <el-col :span="24">
            <editor ref="editor" v-model="data.Content" :height="500" />
          </el-col>
        </el-row>
        <el-divider>附件列表</el-divider>
        <el-row>
          <el-col :span="24" style="padding: 0 18px;">
            <attach-upload ref="attachUpload" :fileList="fileList" :key-id="data.ArticleId" />
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import editDialogMixin from "@/mixins/editDialog";
import editor from "@/components/common/editor";
import attachUpload from "./upload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    editor,
    attachUpload
  },
  data() {
    let nowDate = new Date();
    let user = this.$store.state.user;
    return {
      api: require("@/api/web/article").default,
      data: {
        ArticleId: 0,
        Title: "",
        ColumnId: 1,
        Content: "",
        ContentText: "",
        Source: "",
        Publisher: user.name,
        PublishTime: nowDate,
        IsTop: false,
        Sort: 0,
        Status: 0,
        Attachments: [],
      },
      fileList: [],
      rules: {
        Title: [{ required: true, message: "标题不能为空" }],
        Publisher: [{ required: true, message: "发布人不能为空" }],
        PublishTime: [{ required: true, message: "发布时间不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      console.log("onEditOpened", data);
      this.fileList = this.data.Attachments;
      // this.$refs.attachUpload.getData({ RecordId: this.data.ArticleId });
    },
    onBeforeSave(data) {
      this.data.ContentText = this.$refs.editor.getPlainText();
      this.data.PublishTime = this.$commonJs.toDateStringByFormat(
        this.data.PublishTime
      );
      let fl = this.$refs.attachUpload.fileList;
      let fd = this.$refs.attachUpload.fileDel;
      this.data.Attachments = [];
      fl.forEach(e => {
        if(e.T === undefined) {
          e.T = 0;
          this.data.Attachments.push(e);
        }
      })
      this.data.Attachments = this.data.Attachments.concat(fd);
      // console.log(this.data.Attachments)
      // return false;
      return true;
    },
    onClosed() {
      this.fileList = [];
      this.$refs.attachUpload.clear();
    },
  },
};
</script>